<template>
  <div id="footer" class="container-fluid">
    <div class="guanzhu">
      <div class="footer_box col-xs-6 col-sm-6 col-md-6 ">
        <img
          class="img-responsive img_shuj"
          src="@/assets/img/tu15.png"
          alt="大数据管理系统"/>
        <p class="sys" >
          扫一扫 关注家校云
        </p>
      </div>
      <div class="col-xs-6 col-sm-6 col-md-6 tepdin" >
        <div class="row container-fuild visible-lg-block visible-md-block" >
          <div class="col-xs-12 col-sm-12 col-md-4 row-box" >
            <img
              class="img-responsive"
              src="@/assets/img/tu14.png"
              alt="大数据管理系统"
            />
          </div>
          <div class="col-xs-12 col-sm-12 col-md-8" style="color: #169ff6">
            <p class="font19">乾道技术（深圳）有限公司</p>
            <p class="font16">智慧校园安全方案解决专家</p>
          </div>
        </div>
        <p class="phone-title" >咨询热线：</p>
        <p class="phone">0755-23700060</p>
        <p class="youxiang" >
          邮箱：jin.liwei@szqdjs.com
        </p>
        <p class="dizhi" >地址：广东省深圳市宝安区创锦1号B座B207</p>
      </div> 
    </div>

    <div class="row xianxi" >
      <div class="col-xs-12 col-sm-12 col-md-6 dingbu" >
        <p>全方位实现校园信息化，让校园一切尽在掌控,全新构建一个智能化校园</p>
        <p>平台简单易用、易管理、可全面推广普及</p>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-6 xitou" >
        <div class="row">
          <div class="col-xs-4 col-sm-6 col-md-4 server-wrapper">
            <div class=" slideInUp" >
            <img src="@/assets/img/top/1.png" alt="logo" class="center-block"> 
            <p class="text-center title">  全方位管理</p> 
            <div class="text-center"></div>
            </div>
          </div>
        <div class="col-xs-4 col-sm-6 col-md-4 server-wrapper">
            <div class="server-block wow slideInUp" >
            <img   src="@/assets/img/top/2.png" alt="logo" class="center-block"> 
            <p class="text-center title">  高效智能</p> 
            <div   class="text-center"></div>
            </div>
          </div>
         <div class="col-xs-4 col-sm-6 col-md-4 server-wrapper">
            <div class="server-block wow slideInUp">
            <img src="@/assets/img/top/3.png" alt="logo" class="center-block"> 
            <p class="text-center title">  多样化</p> 
            <div   class="text-center"></div>
            </div>
          </div>
        </div>
      </div>  
    </div>
    </div>
  </div>
</template>
<script>
import '../assets/css/footer.css'
export default {
  
  name: "Footer",
  data() {
    return {};
  },
};
</script>
<style scoped>

</style>




// WEBPACK FOOTER //
// src/components/Footer.vue